/* RESPONSIBLE TEAM: team-ai-insights */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import { taskFor } from 'ember-concurrency-ts';
import type Transition from '@ember/routing/transition';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';

export default class TaskSuggestionsRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare permissionsService: $TSFixMe;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;

  analytics = {
    section: 'automation',
    place: 'task-suggestions',
  };

  get titleToken() {
    return this.intl.t('automation.analyze.task-suggestions.title');
  }

  async beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
    let promises = [taskFor(this.reportingMetrics.setup).perform()];
    await Promise.all(promises);
  }
}
